import { Controller } from '@hotwired/stimulus';

// Enforces feature dependencies on the organisation role form.
// When a prerequisite feature has neither "default" nor "optional" checked,
// the dependent feature's checkboxes are disabled and unchecked.
//
// Each feature row must have data-feature-role-dependency-target="featureRow"
// and data-feature-key="<feature_key>".
export default class extends Controller {
  static targets = ['featureRow'];
  static values = { map: Object }; // { dependent: prerequisite }

  connect() {
    this.enforce();
  }

  enforce() {
    this.featureRowTargets.forEach((row) => {
      const key = row.dataset.featureKey;
      const prerequisite = this.mapValue[key];
      if (!prerequisite) return;

      const prerequisiteRow = this.featureRowTargets.find(
        (r) => r.dataset.featureKey === prerequisite
      );
      if (!prerequisiteRow) return;

      const prerequisiteEnabled = this.isFeatureRowEnabled(prerequisiteRow);
      const prerequisiteLabel = this.featureLabel(prerequisiteRow);
      const checkboxes = row.querySelectorAll('input[type="checkbox"]');

      checkboxes.forEach((cb) => {
        if (!prerequisiteEnabled) {
          cb.checked = false;
          cb.disabled = true;
          cb.title = `${prerequisiteLabel} must be enabled`;
        } else {
          cb.disabled = false;
          cb.removeAttribute('title');
        }
      });
    });
  }

  featureLabel(row) {
    const span = row.querySelector('span');
    return span ? span.textContent.trim() : '';
  }

  isFeatureRowEnabled(row) {
    const defaultCb = row.querySelector(
      'input[type="checkbox"][name$="[default]"]'
    );
    const optionalCb = row.querySelector(
      'input[type="checkbox"][name$="[optional]"]'
    );

    return (
      (defaultCb && defaultCb.checked) || (optionalCb && optionalCb.checked)
    );
  }
}
